(function(){
  function refreshCartCount(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(node){node.textContent=cart.item_count;});
    }).catch(function(){});
  }

  document.querySelectorAll('[data-gallery]').forEach(function(gallery){
    var slides=[].slice.call(gallery.querySelectorAll('[data-slide]'));
    var thumbs=[].slice.call(gallery.querySelectorAll('[data-thumb]'));
    var active=0;
    function show(index){
      if(!slides.length) return;
      active=(index+slides.length)%slides.length;
      slides.forEach(function(slide,i){slide.classList.toggle('is-active',i===active);});
      thumbs.forEach(function(thumb,i){
        var isActive=i===active;
        thumb.classList.toggle('is-active',isActive);
        thumb.setAttribute('aria-current',isActive ? 'true' : 'false');
        if(isActive && typeof thumb.scrollIntoView === 'function'){
          thumb.scrollIntoView({behavior:'auto',block:'nearest',inline:'center'});
        }
      });
    }
    thumbs.forEach(function(thumb,i){thumb.addEventListener('click',function(){show(i);});});
    var prev=gallery.querySelector('[data-prev]');
    var next=gallery.querySelector('[data-next]');
    if(prev) prev.addEventListener('click',function(){show(active-1);});
    if(next) next.addEventListener('click',function(){show(active+1);});
  });

  var productPage=document.querySelector('[data-product-page]');
  if(productPage){
    var variantsNode=document.querySelector('[data-product-variants]');
    var variants=[];
    try{variants=JSON.parse(variantsNode ? variantsNode.textContent : '[]');}catch(e){}
    var variantInput=document.querySelector('[data-variant-id]');
    var colorOneLabel=document.querySelector('[data-color-label-one]');
    var colorTwoLabel=document.querySelector('[data-color-label-two]');
    var propOne=document.querySelector('[data-property-color-one]');
    var propTwo=document.querySelector('[data-property-color-two]');
    var priceNode=document.querySelector('[data-price]');
    var compareNode=document.querySelector('[data-compare]');
    var form=document.querySelector('[data-product-form]');
    var stickyAtc=document.querySelector('[data-sticky-atc]');
    var stickyAtcPrice=document.querySelector('[data-sticky-atc-price]');
    var bundleTarget=document.querySelector('[data-bundle-target]');
    var serumGiftVariantId=Number(productPage.getAttribute('data-serum-gift-variant-id') || 0);
    var serumGiftOffer=productPage.getAttribute('data-serum-gift-offer') || 'Free Batana hair oil serum';
    var bonusGiftVariantId=Number(productPage.getAttribute('data-bonus-gift-variant-id') || 0);
    var bonusGiftOffer=productPage.getAttribute('data-bonus-gift-offer') || 'Free gift';
    var paidOfferLabel=productPage.getAttribute('data-paid-offer-label') || '1 Hydra Brusheo + 1 free';
    var freeOfferLabel=productPage.getAttribute('data-free-offer-label') || 'Free Hydra Brusheo';
    var firstColorProperty=productPage.getAttribute('data-first-color-property') || 'First brush color';
    var freeColorProperty=productPage.getAttribute('data-free-color-property') || 'Free brush color';
    var isFrench=(document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('fr') === 0;
    var atcLabel=isFrench ? 'Ajouter au panier' : 'Add to cart';
    var soldOutLabel=isFrench ? 'Rupture de stock' : 'Sold out';
    var stickyLabel=isFrench ? 'Choisir mon offre' : 'Choose my offer';
    function money(cents){
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency
        }).format((Number(cents || 0) / 100));
      } catch(e) {
        return (Number(cents || 0) / 100).toFixed(2);
      }
    }
    function setMainVariant(input){
      var variant=variants.filter(function(v){return String(v.id)===String(input.value);})[0];
      if(!variant) return;
      if(variantInput) variantInput.value=variant.id;
      if(colorOneLabel) colorOneLabel.textContent=input.getAttribute('data-color-name') || variant.option1;
      if(propOne) propOne.value=input.getAttribute('data-color-name') || variant.option1;
      var formattedPrice = input.getAttribute('data-price-formatted') || money(variant.price);
      var formattedCompare = input.getAttribute('data-compare-formatted') || money(variant.compare_at_price || 5990);
      if(priceNode) priceNode.textContent=formattedPrice;
      if(compareNode) compareNode.textContent=formattedCompare;
      if(stickyAtcPrice) stickyAtcPrice.textContent=formattedPrice;
      var atc=document.querySelector('.atc,.sc-atc');
      if(atc){
        atc.disabled=!variant.available;
        atc.textContent=variant.available ? atcLabel + ' - ' + formattedPrice : soldOutLabel;
      }
      if(stickyAtc){
        stickyAtc.disabled=!variant.available;
        stickyAtc.innerHTML=variant.available ? stickyLabel + '&nbsp;<span data-sticky-atc-price>' + formattedPrice + '</span>' : soldOutLabel;
        stickyAtcPrice=stickyAtc.querySelector('[data-sticky-atc-price]');
      }
    }
    document.querySelectorAll('[data-color-one]').forEach(function(input){
      input.addEventListener('change',function(){setMainVariant(input);});
    });
    document.querySelectorAll('[data-color-two]').forEach(function(input){
      input.addEventListener('change',function(){
        var name=input.getAttribute('data-color-name') || input.value;
        if(colorTwoLabel) colorTwoLabel.textContent=name;
        if(propTwo) propTwo.value=name;
      });
    });
    var selectedTwo=document.querySelector('[data-color-two]:checked');
    if(selectedTwo && propTwo) propTwo.value=selectedTwo.getAttribute('data-color-name') || selectedTwo.value;

    if(form){
      if(stickyAtc){
        stickyAtc.addEventListener('click',function(){
          var target=bundleTarget || form;
          if(!target) return;
          target.scrollIntoView({behavior:'smooth',block:'center'});
          var firstChoice=target.querySelector('[data-color-one]');
          if(firstChoice) {
            setTimeout(function(){ firstChoice.focus({preventScroll:true}); }, 450);
          }
        });

        if(bundleTarget && 'IntersectionObserver' in window){
          var stickyObserver=new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
              stickyAtc.classList.toggle('is-hidden', entry.isIntersecting);
            });
          }, {threshold:0.28});
          stickyObserver.observe(bundleTarget);
        }
      }

      form.addEventListener('submit',function(event){
        event.preventDefault();
        event.stopImmediatePropagation();
        if(form.dataset.atcBusy === 'true') return;
        form.dataset.atcBusy = 'true';
        var atcButton = form.querySelector('[type="submit"], .sc-atc, .atc');
        if(atcButton) atcButton.disabled = true;
        var paidVariantId=variantInput ? variantInput.value : '';
        var selectedFree=document.querySelector('[data-color-two]:checked');
        var freeVariantId=selectedFree ? selectedFree.getAttribute('data-free-variant-id') : paidVariantId;
        var paidColor=propOne ? propOne.value : '';
        var freeColor=propTwo ? propTwo.value : '';
        var replaceVariantIds=variants.map(function(variant){return Number(variant.id);}).filter(Boolean);
        var payload={
          items:[
            {
              id:Number(paidVariantId),
              quantity:1,
              properties:(function(){
                var properties={Offer:paidOfferLabel};
                properties[firstColorProperty]=paidColor;
                properties[freeColorProperty]=freeColor;
                return properties;
              })()
            },
            {
              id:Number(freeVariantId),
              quantity:1,
              properties:(function(){
                var properties={_gift:'true',gift_free:'true',Offer:freeOfferLabel};
                properties[freeColorProperty]=freeColor;
                return properties;
              })()
            }
          ]
        };
        if(serumGiftVariantId){
          payload.items.push({
            id:serumGiftVariantId,
            quantity:1,
            properties:{
              _gift:'true',
              gift_free:'true',
              gift_serum:'true',
              Offer:serumGiftOffer
            }
          });
        }
        if(bonusGiftVariantId){
          payload.items.push({id:bonusGiftVariantId,quantity:1,properties:{_gift:'true',gift_free:'true',gift_bonus:'true',Offer:bonusGiftOffer}});
        }
        document.dispatchEvent(new CustomEvent('cart:add',{
          detail:{
            items:payload.items,
            source:'product-bogo',
            replaceVariantIds:replaceVariantIds,
            onSuccess:function(){
              refreshCartCount();
              form.dataset.atcBusy = 'false';
              if(atcButton) atcButton.disabled = false;
            },
            onError:function(){
              form.dataset.atcBusy = 'false';
              if(atcButton) atcButton.disabled = false;
              /* The drawer owns the single Shopify /cart/add.js request.
                 Retrying here could add the paid brush twice and publish two ATC events. */
              if(typeof window.announceLive === 'function') {
                window.announceLive(isFrench ? 'Impossible d’ajouter l’offre. Veuillez réessayer.' : 'We could not add the offer. Please try again.');
              }
            }
          }
        }));
      });
    }
  }

  var reviewList=document.querySelector('[data-sc-review-list]');
  var reviewButton=document.querySelector('[data-sc-review-more]');
  if(reviewList && reviewButton){
    reviewButton.addEventListener('click',function(){
      var expanded=reviewList.classList.toggle('is-expanded');
      reviewButton.setAttribute('aria-expanded',expanded ? 'true' : 'false');
      reviewButton.textContent=expanded ? 'Show fewer reviews' : 'Show more reviews';
    });
  }
})();
